// frontend/src/pages/MAFA.jsx

import React from "react";

const MAFA = () => {
  return (
    <main style={{ padding: "60px 20px" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>

        {/* PAGE IMAGE */}
        <img
          src="/images/mafa-concept.png"
          alt="MAFA – Modular Air Filtration Augmentation Concept"
          style={{
            width: "100%",
            maxHeight: "420px",
            objectFit: "cover",
            borderRadius: "12px",
            marginBottom: "40px"
          }}
        />

        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          MAFA – Modular Air Filtration Augmentation
        </h1>

        <p style={{ fontSize: "18px", color: "#555", marginBottom: "30px" }}>
          MAFA is an Aerzen Air research and development initiative focused on enhancing
          airflow quality in large, enclosed, and high-occupancy environments through
          modular filtration concepts.
        </p>

        <h2 style={{ fontSize: "26px", marginBottom: "12px" }}>
          Concept Overview
        </h2>

        <p style={{ fontSize: "17px", color: "#555", marginBottom: "20px" }}>
          The MAFA concept explores supplemental filtration modules that integrate with
          existing airflow paths in environments such as transit coaches, terminals,
          halls, and large public enclosures. The objective is to improve particulate
          reduction without altering primary HVAC systems.
        </p>

        <h2 style={{ fontSize: "26px", marginBottom: "12px" }}>
          Current Status
        </h2>

        <ul style={{ fontSize: "17px", color: "#444", lineHeight: "1.8" }}>
          <li>Research and airflow study phase</li>
          <li>Concept validation and simulation</li>
          <li>No commercial deployment at this stage</li>
        </ul>

        <p style={{ fontSize: "16px", color: "#777", marginTop: "30px" }}>
          MAFA is a conceptual initiative and does not represent a commercial product
          offering at this time.
        </p>
      </div>
    </main>
  );
};

export default MAFA;
